/** Largest organization logo an account may upload. */
export const MAX_ACCOUNT_LOGO_SIZE_BYTES = 2 * 1024 * 1024;

/** Most pixels an organization logo may have on either side. */
export const MAX_ACCOUNT_LOGO_DIMENSION_PX = 4000;

/** File extensions an organization logo may carry. */
export const ACCOUNT_LOGO_EXTENSIONS = ['.png', '.jpg', '.jpeg'] as const;

/** MIME types an organization logo may have, matching its extensions. */
export const ACCOUNT_LOGO_MIME_TYPES = ['image/png', 'image/jpeg'] as const;
